<template>
    <div class="mobile-app-area launch-area" style="padding: 0px;">
        <div class="container">
            <div class="row align-items-center right-side-flex">
                <div class="col-lg-6 col-md-12">
                    <div class="about-content">
                        <span class="sub-title text-uppercase">App Services</span>
                        <h2>Ready-to-Launch Mobile App Services</h2>
                        <p>
                            Cut development time with our pre-built, customizable mobile app solutions, enhanced with AI
                            features like smart recommendations, automated workflows, and predictive analytics. Perfect
                            for startups and SMEs aiming to launch quickly with industry-standard features and
                            intelligent capabilities.
                        </p>
                        <div class="features-text">
                            <h6>Industries</h6>
                            <p>Food delivery, logistics, eCommerce, healthcare, education, and more.</p>
                            <h6>Key Benefits</h6>
                            <p>Faster time-to-market, AI-driven personalization, tested UI/UX, cost-effective.</p>
                            <h6>Technologies</h6>
                            <p>Flutter, React Native, Kotlin, Swift, TensorFlow Lite, Firebase, AWS Amplify.</p>
                            <button data-v-b4360fc6="" class="default-btn ms-2" style="margin-left:0px !important;">Explore Solutions</button>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-12">
                    <div class="about-img">
                        <img src="../../assets/images/Mobile-App.png" alt="launch app">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: "MobileAppServices",
};
</script>

<style scoped>

</style>
